var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.warehousemanagement")) +
                " > " +
                _vm._s(_vm.warehouse.warehouse_name) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("BaseTopBarContent", { attrs: { className: "right" } }, [
            !_vm.loading
              ? _c(
                  "div",
                  { staticClass: "action" },
                  [
                    _vm.hasRoleDelete
                      ? _c("BaseActionDropdown", {
                          attrs: {
                            icon: "fas fa-cog",
                            text: _vm.$t("button.options"),
                            items: [
                              {
                                icon: "fas fa-trash",
                                iconClassName: "text-danger",
                                text: _vm.$t("button.delete"),
                                textClassName: "text-danger",
                                value: "delete"
                              }
                            ]
                          },
                          on: { onSelect: _vm.handleSelectOption }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("WmsWarehouseForm", {
            attrs: {
              state: _vm.warehouse,
              warehouses: _vm.warehouses,
              products: _vm.products,
              binLocations: _vm.warehouse.bin_locations,
              isSubmitted: _vm.isSubmitted,
              disabled: _vm.disabled || !_vm.hasRoleEdit,
              form: _vm.form,
              showActionButtons: _vm.hasRoleEdit
            },
            on: {
              "update:form": function($event) {
                _vm.form = $event
              },
              onSubmit: _vm.handleSubmit
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("baseConfirmDeleteModal", {
        attrs: { show: _vm.modal.show, loading: _vm.modal.loading },
        on: {
          onClose: _vm.handleCloseModal,
          onCancel: _vm.handleCancleModal,
          onSubmit: _vm.handleSumitModal
        }
      }),
      _vm._v(" "),
      _c("BaseAlertModal", {
        attrs: {
          id: _vm.deletePrimaryWarehoseWarningModal,
          headerText: _vm.$t("message.primarywarehousecannotbedeleted")
        }
      }),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0aa9c5b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aa9c5b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/warehouse/Edit.vue
// module id = null
// module chunks = 